const data = {
  primaryColor: "#F44336",
  lightColor: true,
  title: "Audio Recorder",
  category: "Tools",
  icon: "/images/app-icons/audio-recorder.png",
  shortDescription:
    "Easy-to-use application that allows users to record and playback audio in the M4A format. Application has simple interface, where users can record voice notes, memos, meetings, and more, and playback their recordings. The app also features tools for managing and sharing recordings.",
  slogan:
    "Easy-to-use application designed for recording audio on your Android device",
  fullDescription:
    "Audio Recorder is an easy-to-use application designed for recording audio on your Android device. With this application, you can easily record voice notes, memos, business meetings, interviews, lectures, speeches, songs, concerts, sleep talking, or anything else. You can playback your recordings. Right now it is supported only recording in M4A format, but in future will be supported audio formats expanded. There are also included features like record and playback audio in the background, display the sound level in decibels in a graph, and provides tools to rename, share, and delete recordings. Additionally, there is a simple list of recordings for easy management of audio files.",
  usesCases: [
    "Record voice notes, memos, business meetings, interviews, lectures, speeches, songs, concerts, sleep talking or anything else.",
  ],
  properties: [
    "Recording audio",
    "Playback records",
    "Supported recording format M4A",
    "Record and playback in background",
    "Display sound level in decibels in graph",
    "Rename, share, delete record",
    "List of recordings",
  ],
  services: [],
  pricing: "Free",
  android: {
    permissions: [
      { name: "Microphone", reason: "Recording audio" },
      { name: "Storage", reason: "Saving and managing recordings" },
    ],
    requirements: "Device microphone and storage",
    requiredAndroidVersion: "10.0 and up",
    versioning: {
      releasedOn: new Date(2021, 6, 30),
      currentVersion: "1.1",
      updatedOn: new Date(2023, 1, 27),
    },
    availableOn: {
      googlePlayURL:
        "https://play.google.com/store/apps/details?id=dev.davidsimak.audiorecorder",
    },
    languages: {
      supported: "English",
      inProgress: null,
    },
    deviceCompatibility: {
      phone: true,
      tablet: true,
    },
    techInformation: {
      language: "Java 11",
      logging: "ACRA",
      database: null,
      integrations: [],
      libraries: [],
      plugins: [],
    },
    images: [
      {
        title: "Main screen",
        url: "/images/project-screenshots/audio-recorder/audio-recorder-android-1.png",
        description: "List of all recorded audio",
      },
      {
        title: "Audio player",
        url: "/images/project-screenshots/audio-recorder/audio-recorder-android-2.png",
        description: "Audio recorder player",
      },
      {
        title: "Audio recorder",
        url: "/images/project-screenshots/audio-recorder/audio-recorder-android-3.png",
        description:
          "Audio recording screen with visualizer of intensity recorded audio",
      },
      {
        title: "Audio recorder",
        url: "/images/project-screenshots/audio-recorder/audio-recorder-android-4.png",
        description:
          "Audio recording screen with visualizer of intensity recorded audio",
      },
      {
        title: "Audio recorder saving",
        url: "/images/project-screenshots/audio-recorder/audio-recorder-android-5.png",
        description:
          "Audio recording screen with visualizer and possibility to rename, save or delete recorded audio ",
      },
    ],
  },
  frontend: null,
  backend: null,
};

class AudioRecorderProjectData {
  get() {
    return data;
  }

  getAsItem() {
    return {
      tag: "audio-recorder",
      title: data.title,
      category: data.category,
      icon: data.icon,
      shortDescription: data.shortDescription,
      platform: {
        android: data.android !== null,
        frontend: data.frontend !== null,
        backend: data.backend !== null,
      },
    };
  }

  getIfCategoryIsMatched(categoryName) {
    if (categoryName === data.category) {
      return this.getAsItem();
    }

    return undefined;
  }
}

export default new AudioRecorderProjectData();
